/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=1973ef9c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1973ef9c&lang=less&scoped=true"

import exportComponent from "/Users/fiture/Fiture/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1973ef9c"]])

export default __exports__